import { IHorario } from '@/@types/GradeHorarioSalaAula';
import { TableCell, TableRow } from '@/components/ui/table';

interface IRowTableGradeHorarioProps {
    /** Objeto representando o horário da aula. */
    horario: IHorario;
}

/**
 * Componente para exibir uma linha da tabela de grade de horário.
 * @param horario Objeto representando o horário da aula.
 * @returns Linha da tabela de grade de horário.
 */

const RowTableGradeHorario = ({ horario }: IRowTableGradeHorarioProps) => {

    const getWeekDayName = (weekDayNumber: number) => {
        // retorna o dia da semana pelo número, ex 2 == Segunda-Feira
        const diasSemana = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'];
        return diasSemana[weekDayNumber - 1];
    };

    return (
        <TableRow className='text-lg font-medium'>
            <TableCell>{getWeekDayName(horario.DSEM)}</TableCell>
            <TableCell>{horario.HINIAULAI} - {horario.HINIAULAF}</TableCell>
            <TableCell className='text-colorPrimary text-center'>{horario.CSALA || '-'}</TableCell>
            <TableCell className='text-colorSecondary'>{horario.CDISC}</TableCell>
            <TableCell>({horario.CTURMA}) {horario.NOME_DISCI}</TableCell>
            <TableCell>{horario.NOME_DOCENTE}</TableCell>
        </TableRow>
    );
}

export { RowTableGradeHorario };